import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import useAuthStore from '../context/authStore';
import { useLoader } from '../components/shared/LoaderContext';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const { login } = useAuthStore();
  const { showLoader, hideLoader } = useLoader();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const interval = showLoader('Signing in...');
    try {
      const user = await login(form.email, form.password);
      hideLoader(interval);
      toast.success(`Welcome back, ${user.firstName}!`);
      navigate(user.role === 'ADMIN' ? '/admin' : '/dashboard');
    } catch (err) {
      hideLoader(interval);
      toast.error(err.response?.data?.message || 'Login failed');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f2440 0%, #1a3a5c 50%, #2563a8 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
    }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 32, color: 'white' }}>
          <div style={{
            width: 90, height: 90, borderRadius: '50%', background: 'white',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px', overflow: 'hidden',
            border: '3px solid var(--accent)', boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
          }}>
            <img src="/logo.png" alt="BPS"
              style={{ width: '80%', height: '80%', objectFit: 'contain' }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = '<div style="color:#1a3a5c;font-weight:700;font-size:18px;">BPS</div>';
              }} />
          </div>
          <h1 style={{ fontSize: 26, fontFamily: "'Playfair Display', serif", marginBottom: 6 }}>
            Bombay Psychiatric Society
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 14 }}>Member Portal — Sign In</p>
        </div>

        <div className="card" style={{ padding: 36 }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input type="email" className="form-input" placeholder="your@email.com"
                value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <div style={{ position: 'relative' }}>
                <input type={showPass ? 'text' : 'password'} className="form-input"
                  placeholder="••••••••" value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required style={{ paddingRight: 44 }} />
                <button type="button" onClick={() => setShowPass(!showPass)} style={{
                  position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)'
                }}>
                  {showPass ? <EyeOff size={17} /> : <Eye size={17} />}
                </button>
              </div>
              <div style={{ textAlign: 'right' }}>
                <Link to="/forgot-password" style={{ fontSize: 13, color: 'var(--primary-light)', textDecoration: 'none' }}>
                  Forgot Password?
                </Link>
              </div>
            </div>
            <button type="submit" className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center', padding: '12px' }}>
              Sign In
            </button>
          </form>
          <div style={{
            textAlign: 'center', marginTop: 24, paddingTop: 20,
            borderTop: '1px solid var(--border)', fontSize: 14, color: 'var(--text-muted)'
          }}>
            New to the Society?{' '}
            <Link to="/signup" style={{ color: 'var(--primary-light)', fontWeight: 600, textDecoration: 'none' }}>
              Create Account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
